import AcSettlementsOverviewAllTab from './all/all';

export default {
  All: AcSettlementsOverviewAllTab,
};
